// extracted by mini-css-extract-plugin
module.exports = {"list":"Navigations-module--list--2CKYj","listItem":"Navigations-module--listItem--3ScP_","link":"Navigations-module--link--11qBN","selected":"Navigations-module--selected--1xfoz"};